import { get_array_item } from 'src/js/utils';

const number_format = new Intl.NumberFormat('en-US');

document.addEventListener("DOMContentLoaded", () => {
    console.log("Init Home_Design");

    document.querySelectorAll(".item-home-design-overview").forEach(el => {
        const data = el.dataset.design ? JSON.parse(el.dataset.design) : {};

        new Home_Design(el, data);
    });
});

export default class Home_Design {

    constructor(el, data){
        this.el = el;
        this.data = data;
        
        this.render = {
            name: el.querySelector('.name'),
            type: el.querySelector('.type'),
            state: el.querySelector('.state'),
            bed: el.querySelector('.bed'),
            bath: el.querySelector('.bath'),
            car_park: el.querySelector('.car_park'),
            toilet: el.querySelector('.toilet'),
            house_length: el.querySelector('.house_length .v'),
            house_width: el.querySelector('.house_width .v'),
            house_area: el.querySelector('.house_area .v'),
            other_dimensions: el.querySelector('.other_dimensions'),
            price: el.querySelector('.price .value'),
            image: el.querySelector('.image img'),
            floorplan_image: el.querySelector('.floorplan_image img'),
        }

        this.design_options_init();
    }

    design_options_init(){
        
        const options = this.el.querySelectorAll('.configurations .option');

        this.current_option = options[0];
        
        options.forEach(option=>{

            option.design_option_data = get_array_item( 'id', option.dataset.id, this.data.design_options);
            
            option.addEventListener('click', ()=>{
                this.select_option(option);
            })
        })

        this.design_options = options;

        // initialize accordion of initial design option
        this.init_accordion();
    }

    select_option(option){
        
        if( option.classList.contains('selected') ) return;
        
        this.current_option.classList.remove('selected');

        option.classList.add('selected');
        this.current_option = option;

        // render selected option data html
        this.render_option(option.design_option_data);

        if( typeof this.on_select === 'function' ) {
            this.on_select();
        }
    }

    render_option(data){
        
        const text_content_fields = [
            'name',
            'type',
            'bed',
            'bath',
            'car_park',
            'toilet',
        ];

        text_content_fields.forEach(field =>{
            if( !this.render[field] ) return;
            this.render[field].textContent = data[field];
        })
        
        // dimensions
        if( this.render.house_length ) {
            this.render.house_length.textContent = data.house_length + 'm';
        }
        
        if( this.render.house_width ) {
            this.render.house_width.textContent = data.house_width + 'm';
        }

        if( this.render.house_area ) {
            this.render.house_area.textContent = data.house_area + 'm²';
        }

        // price
        if( this.render.price ) {
            this.render.price.textContent = number_format.format(data.price);
        }
        
        // images
        if( this.render.image ) {
            this.render.image.src = data.image_url;
        }
        
        if( this.render.floorplan_image ) {
            this.render.floorplan_image.src = data.floorplan_image_url;
        }
        
        this.render_other_dimensions(data);
    }
    
    render_other_dimensions(data){
        
        let html = this.get_other_dimensions_html(data);

        this.render.other_dimensions.innerHTML = html;
        
        if( html ) {
            this.init_accordion();
        }
    }

    get_other_dimensions_html(data){

        if( typeof data.other_dimensions_html !== 'undefined' ) {
            // from cache
            return data.other_dimensions_html;
        }
        
        if( !data.other_dimensions ) {
            data.other_dimensions_html = '';
            return '';
        }

        let html = '';
        
        data.other_dimensions.forEach(group=>{

            if( !group.list ) return;

            html += '<div class="group">';
                html += '<div class="group-heading">'+ group.heading +'</div>';
                html += '<div class="group-content">';
                    html += '<div class="list">';
                    group.list.forEach(list_item=>{
                        html += '<div class="list-item">';
                            html += '<div class="l">'+ list_item.label +'</div>';
                            html += '<div class="v">'+ list_item.value +'</div>';
                        html += '</div>';
                    })
                    html += '</div>';
                html += '</div>';
            html += '</div>';
        })

        // cache
        data.other_dimensions_html = html;
        
        return html;
    }

    init_accordion() {

        const isMobile = window.innerWidth <= 768; 

        this.render.other_dimensions.querySelectorAll('.group').forEach(group => {

            const content = group.querySelector('.group-content');
            const heading = group.querySelector('.group-heading');

            // Expanded on desktop, collapsed on mobile
            if (!isMobile) {
                group.classList.add('active');
                content.style.height = content.children[0]?.offsetHeight + 'px';
            } else {
                group.classList.remove('active');
                content.style.height = '0px';
            }

            heading.addEventListener('click', () => {

                group.classList.toggle('active');

                let isActive = group.classList.contains('active');

                let height = isActive ? content.children[0].offsetHeight : 0;

                content.style.height = height + 'px';
            });
        });
    }

}

